import "../styles/main.css";

import { initSharedBehaviors } from "./_shared.js";

import { initMenu } from "../behaviors/menu.js";
import { initStickyHeader } from "../behaviors/sticky-header.js";
import { initSmoothScroll } from "../behaviors/smooth-scroll.js";
import { initMetrika } from "../behaviors/metrika.js";
import { initSocialLinks } from "../behaviors/social-links.js";
import { initCopyButtons } from "../behaviors/copy-button.js";

import { initHeroParticles } from "../behaviors/hero-particles.js";
import { initHeroCarousel } from "../behaviors/hero-carousel.js";
import { initPortfolioTabs } from "../behaviors/portfolio-tabs.js";
import { initFaqAccordion } from "../behaviors/faq-accordion.js";
import { initFeedbackForm } from "../behaviors/feedback-form.js";
import { mountCalculator } from "../islands/calculator.js";


function init() {
  initSharedBehaviors();
  initHeroParticles().catch((e) => console.error(e));
  initHeroCarousel();
  initPortfolioTabs();
  initFaqAccordion();
  mountCalculator();
  initFeedbackForm();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
